import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { casasInviertis, edificios, rentaAntigua } from './inmuebles-link';
import { PropertiesService } from '@shared/services/api/properties.service';
import { SellService } from '@shared/services/api/sell.service';
import { ASSETS_API_URL, SERVER_FRONT_URL } from '@app/app.constants';

// Slug para la ruta (Málaga -> malaga, Torrejón de Ardoz -> torrejon-de-ardoz)
function slugify(value: string): string {
  return (value || '')
    .replace(/[ ]/g, '-')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

// Quita tildes/dieresis manteniendo mayusculas y espacios (Málaga -> Malaga)
function removeAccents(value: string): string {
  return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

@Component({
  selector: 'app-lista-links-home',
  templateUrl: './lista-links-home.component.html',
  styleUrls: ['./lista-links-home.component.scss'],
})
export class ListaLinksHomeComponent implements OnInit {
  frontEndServer = SERVER_FRONT_URL;
  picturesServer = ASSETS_API_URL;
  edificios = false;
  pisos = false;
  casas = false;
  localidades = false;
  provincia = true;
  renta = false;
  paginaLoc = 1;
  paginaFlats = 1;
  navegador = [
    'edificios',
    'pisos',
    'casas',
    'localidades',
    'provincias',
    'renta',
  ];
  currentTime = new Date().getTime();
  /* Edificios  */
  arrayEdificios: any[] = edificios;
  templateHTMLEdificio = '';
  templateHTMLEdificioEn = '';
  /* Renta Antigua  */
  arrayRentaAntigua: any[] = rentaAntigua;
  templateHTMLRentaAntigua = '';
  templateHTMLRentaAntiguaEn = '';
  /*Casa*/
  arrayCasa: any[] = casasInviertis;
  templateHTMLCasa = '';
  templateHTMLCasaEn = '';
  /*Provincias*/
  arrayProvincias: any[] = [];
  templateHTMLProvincias = '';
  templateHTMLProvinciasEn = '';
  /*Locations*/
  arrayLocations: any[] = [];
  templateHTMLLocations1 = '';
  templateHTMLLocations1En = '';
  templateHTMLLocations2 = '';
  templateHTMLLocations2En = '';
  templateHTMLLocations3 = '';
  templateHTMLLocations3En = '';
  /*PisosApartamentos*/
  pisosApartamentos: any[] = [];
  templateHTMLPisos1 = '';
  templateHTMLPisos2 = '';
  templateHTMLPisos3 = '';
  templateHTMLPisos4 = '';
  templateHTMLPisos5 = '';
  constructor(
    private propertiesService: PropertiesService,
    private sellService: SellService,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    /* Tiempo Last Date */
    const lastUpdate = localStorage.getItem('lastUpdate');
    if (lastUpdate) {
      if (this.validateLocalStorage()) {
        const timeElapsed =
          (this.currentTime - Number(lastUpdate)) / (1000 * 60);
        if (timeElapsed >= 60) {
          this.insertHtmlStore();
        } else {
          this.templateHTMLEdificio = localStorage.getItem(
            'htmlTemplateEdificios'
          );
          this.templateHTMLEdificioEn = localStorage.getItem(
            'htmlTemplateEdificiosEn'
          );
          this.templateHTMLRentaAntigua = localStorage.getItem(
            'htmlTemplateRentaAntigua'
          );
          this.templateHTMLRentaAntiguaEn = localStorage.getItem(
            'htmlTemplateRentaAntiguaEn'
          );
          this.templateHTMLCasa = localStorage.getItem('htmlTemplateCasa');
          this.templateHTMLCasaEn = localStorage.getItem('htmlTemplateCasaEn');
          this.templateHTMLProvincias = localStorage.getItem(
            'htmlTemplateProvincias'
          );
          this.templateHTMLProvinciasEn = localStorage.getItem(
            'htmlTemplateProvinciasEn'
          );
          this.templateHTMLLocations1 = localStorage.getItem(
            'templateHTMLLocations1'
          );
          this.templateHTMLLocations1En = localStorage.getItem(
            'templateHTMLLocations1En'
          );
          this.templateHTMLLocations2 = localStorage.getItem(
            'templateHTMLLocations2'
          );
          this.templateHTMLLocations2En = localStorage.getItem(
            'templateHTMLLocations2En'
          );
          this.templateHTMLLocations3 = localStorage.getItem(
            'templateHTMLLocations3'
          );
          this.templateHTMLLocations3En = localStorage.getItem(
            'templateHTMLLocations3En'
          );

          this.templateHTMLPisos1 = localStorage.getItem('templateHTMLPisos1');
          this.templateHTMLPisos2 = localStorage.getItem('templateHTMLPisos2');
          this.templateHTMLPisos3 = localStorage.getItem('templateHTMLPisos3');
          this.templateHTMLPisos4 = localStorage.getItem('templateHTMLPisos4');
          this.templateHTMLPisos5 = localStorage.getItem('templateHTMLPisos5');
        }
      } else {
        this.insertHtmlStore();
      }
    } else {
      this.insertHtmlStore();
    }
  }

  validateLocalStorage(): boolean {
    const edif = localStorage.getItem('htmlTemplateEdificios');
    const edifen = localStorage.getItem('htmlTemplateEdificiosEn');
    const renta = localStorage.getItem('htmlTemplateRentaAntigua');
    const rentaen = localStorage.getItem('htmlTemplateRentaAntiguaEn');
    const casa = localStorage.getItem('htmlTemplateCasa');
    const casaen = localStorage.getItem('htmlTemplateCasaEn');
    const prov = localStorage.getItem('htmlTemplateProvincias');
    const proven = localStorage.getItem('htmlTemplateProvinciasEn');
    const loc1 = localStorage.getItem('templateHTMLLocations1');
    const loc1en = localStorage.getItem('templateHTMLLocations1En');
    const loc2 = localStorage.getItem('templateHTMLLocations2');
    const loc2en = localStorage.getItem('templateHTMLLocations2En');
    const loc3 = localStorage.getItem('templateHTMLLocations3');
    const loc3en = localStorage.getItem('templateHTMLLocations3En');
    const flat1 = localStorage.getItem('templateHTMLPisos1');
    const flat2 = localStorage.getItem('templateHTMLPisos2');
    const flat3 = localStorage.getItem('templateHTMLPisos3');
    const flat4 = localStorage.getItem('templateHTMLPisos4');
    const flat5 = localStorage.getItem('templateHTMLPisos5');
    return !!(
      edif &&
      edifen &&
      renta &&
      rentaen &&
      casa &&
      casaen &&
      prov &&
      proven &&
      loc1 &&
      loc1en &&
      loc2 &&
      loc2en &&
      loc3 &&
      loc3en &&
      flat1 &&
      flat2 &&
      flat3 &&
      flat4 &&
      flat5
    );
  }

  insertHtmlStore() {
    this.initDataPublications();
    this.propertiesService.getAllProvinces().subscribe((data: any) => {
      this.arrayProvincias = data;
      data.forEach((prov: any) => {
        prov.locations.forEach((loc: any) => {
          loc.prov = prov.description_filter;
          loc.prov_description = prov.description;
          this.arrayLocations.push(loc);
        });
      });
      const locationPaginate = [];
      for (let i = 0; i < this.arrayLocations.length; i += 80) {
        const pedazo = this.arrayLocations.slice(i, i + 80);
        locationPaginate.push(pedazo);
      }
      this.templateHTMLProvincias = this.generateTemplateHTML(
        this.arrayProvincias,
        'Inmuebles alquilados en venta en ',
        'provincias'
      );
      if (locationPaginate.length > 0) {
        this.templateHTMLLocations1 = this.generateTemplateHTML(
          locationPaginate[0],
          'Inmuebles alquilados en venta en ',
          'localidades'
        );
      }
      if (locationPaginate.length > 1) {
        this.templateHTMLLocations2 = this.generateTemplateHTML(
          locationPaginate[1],
          'Inmuebles alquilados en venta en ',
          'localidades'
        );
      }
      if (locationPaginate.length > 2) {
        this.templateHTMLLocations3 = this.generateTemplateHTML(
          locationPaginate[2],
          'Inmuebles alquilados en venta en ',
          'localidades'
        );
      }
      localStorage.setItem(
        'htmlTemplateProvincias',
        this.templateHTMLProvincias
      );
      localStorage.setItem(
        'templateHTMLLocations1',
        this.templateHTMLLocations1
      );
      localStorage.setItem(
        'templateHTMLLocations2',
        this.templateHTMLLocations2
      );
      localStorage.setItem(
        'templateHTMLLocations3',
        this.templateHTMLLocations3
      );
    });
    this.templateHTMLEdificio = this.generateTemplateHTML(
      this.arrayEdificios,
      'Edificios alquilados en venta en ',
      'static'
    );
    this.templateHTMLRentaAntigua = this.generateTemplateHTML(
      this.arrayRentaAntigua,
      'Inmuebles alquilados en venta en ',
      'static'
    );
    this.templateHTMLCasa = this.generateTemplateHTML(
      this.arrayCasa,
      'Casas alquiladas para inversión en ',
      'static'
    );
    localStorage.setItem('lastUpdate', new Date().getTime().toString());
    localStorage.setItem('htmlTemplateEdificios', this.templateHTMLEdificio);
    localStorage.setItem(
      'htmlTemplateRentaAntigua',
      this.templateHTMLRentaAntigua
    );
    localStorage.setItem('htmlTemplateCasa', this.templateHTMLCasa);
  }
  initDataPublications() {
    this.sellService.getProvincesWithPublications().subscribe((data) => {
      data.forEach((prov: any) => {
        let provinces: { description: any; publications: any[] };
        provinces = { description: prov.description, publications: [] };
        prov.locations.forEach((loc: any) => {
          loc.addresses.forEach((address: any) => {
            const publications = {
              reference: address?.properties[0]?.propertyDetail?.reference,
              description: loc.description,
            };
            provinces.publications.push(publications);
          });
        });
        this.pisosApartamentos.push(provinces);
      });
      this.separateFlatApartmentContent();
    });
  }
  separateFlatApartmentContent() {
    let allFlats: any[] = [];
    this.pisosApartamentos.forEach((provinces) => {
      provinces.publications.forEach((publications: any) => {
        allFlats.push(publications);
      });
    });

    const pisoPaginate = [];
    for (let i = 0; i < allFlats.length; i += 80) {
      const pedazo = allFlats.slice(i, i + 80);
      pisoPaginate.push(pedazo);
    }
    if (pisoPaginate.length > 0) {
      this.templateHTMLPisos1 = this.generateFlatApartamentHtmlContent(
        pisoPaginate[0]
      );
    }
    if (pisoPaginate.length > 1) {
      this.templateHTMLPisos2 = this.generateFlatApartamentHtmlContent(
        pisoPaginate[1]
      );
    }
    if (pisoPaginate.length > 2) {
      this.templateHTMLPisos3 = this.generateFlatApartamentHtmlContent(
        pisoPaginate[2]
      );
    }
    if (pisoPaginate.length > 3) {
      this.templateHTMLPisos4 = this.generateFlatApartamentHtmlContent(
        pisoPaginate[3]
      );
    }
    if (pisoPaginate.length > 4) {
      this.templateHTMLPisos5 = this.generateFlatApartamentHtmlContent(
        pisoPaginate[4]
      );
    }
    localStorage.setItem('templateHTMLPisos1', this.templateHTMLPisos1);
    localStorage.setItem('templateHTMLPisos2', this.templateHTMLPisos2);
    localStorage.setItem('templateHTMLPisos3', this.templateHTMLPisos3);
    localStorage.setItem('templateHTMLPisos4', this.templateHTMLPisos4);
    localStorage.setItem('templateHTMLPisos5', this.templateHTMLPisos5);
  }
  generateFlatApartamentHtmlContent(
    array: any,
    language: string = '/es'
  ): string {
    let templateHtml = '';
    array.forEach((provinces: any, index: any) => {
      let html = '';
      html =
        '<div class="grid-item"> <a class="linksDyn"' +
        'href="' +
        this.frontEndServer +
        language +
        '/invertir/propiedad/' +
        provinces.reference +
        '" alt="' +
        'Inmuebles alquilados para invertir en ' +
        provinces.description +
        '">' +
        'En ' +
        provinces.description +
        '</a> </div>';
      templateHtml += html;
    });
    templateHtml += '</div>';
    templateHtml += '</div>';
    return templateHtml;
  }
  generateTemplateHTML(
    data: any[],
    message: string,
    source: string,
    language: string = '/es'
  ): string {
    let templateHtml = '';
    data.forEach((value) => {
      let html = '';
      if (source === 'provincias') {
        const provSlug = slugify(value.description_filter);
        html =
          '<div class="grid-item"> <a class="linksDyn"' +
          'href="' +
          this.frontEndServer +
          language +
          '/invertir/propiedades/' +
          provSlug +
          '?prov=' +
          provSlug +
          '&locationDescription=' +
          removeAccents(value.description).replace(/[ ]/g, '%20') +
          ',%20Provincia' +
          '" alt="' +
          message +
          provSlug +
          '">' +
          'En ' +
          value.description +
          '</a> </div>';
      }
      if (source === 'localidades') {
        const provSlug = slugify(value.prov);
        const citySlug = slugify(value.description_filter);
        html =
          '<div class="grid-item"> <a class="linksDyn"' +
          'href="' +
          this.frontEndServer +
          language +
          '/invertir/propiedades/' +
          provSlug +
          '/' +
          citySlug +
          '?loc=' +
          citySlug +
          '&prov=' +
          provSlug +
          '&locationDescription=' +
          removeAccents(value.description).replace(/[ ]/g, '%20') +
          ',%20Ciudad' +
          '" alt="' +
          message +
          provSlug +
          '/' +
          citySlug +
          '">' +
          'En ' +
          value.prov_description +
          ' - ' +
          value.description +
          '</a> </div>';
      }
      if (source === 'static') {
        html =
          '<div class="grid-item"> <a class="linksDyn"' +
          'href="' +
          this.frontEndServer +
          language +
          '/invertir/propiedad/' +
          value.goTo +
          '" alt="' +
          message +
          value.label +
          '">' +
          'En ' +
          value.label +
          '</a> </div>';
      }
      templateHtml += html;
    });
    return templateHtml;
  }
  cambiaTipo(string: any) {
    switch (string) {
      case 'edificios':
        this.edificios = !this.edificios;
        if (this.edificios) {
          document
            .getElementById('edificios')
            .setAttribute('class', 'links muestra');

          for (let x = 0; x < this.navegador.length; x++) {
            if (this.navegador[x] != 'edificios') {
              document
                .getElementById(this.navegador[x])
                .setAttribute('class', 'links esconde');
            }
          }
          this.pisos =
            this.casas =
            this.localidades =
            this.provincia =
            this.renta =
              false;
        } else {
          document
            .getElementById('edificios')
            .setAttribute('class', 'links esconde');
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
          this.provincia = true;
          this.pisos = this.casas = this.localidades = this.renta = false;
        }
        break;
      case 'pisos':
        this.pisos = !this.pisos;
        if (this.pisos) {
          document
            .getElementById('pisos')
            .setAttribute('class', 'links muestra');

          for (let x = 0; x < this.navegador.length; x++) {
            if (this.navegador[x] != 'pisos') {
              document
                .getElementById(this.navegador[x])
                .setAttribute('class', 'links esconde');
            }
          }
          this.edificios =
            this.casas =
            this.localidades =
            this.provincia =
            this.renta =
              false;
        } else {
          document
            .getElementById('pisos')
            .setAttribute('class', 'links esconde');
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
          this.provincia = true;
          this.edificios = this.casas = this.localidades = this.renta = false;
        }

        break;
      case 'casas':
        this.casas = !this.casas;
        if (this.casas) {
          document
            .getElementById('casas')
            .setAttribute('class', 'links muestra');

          for (let x = 0; x < this.navegador.length; x++) {
            if (this.navegador[x] != 'casas') {
              document
                .getElementById(this.navegador[x])
                .setAttribute('class', 'links esconde');
            }
          }
          this.edificios =
            this.pisos =
            this.localidades =
            this.provincia =
            this.renta =
              false;
        } else {
          document
            .getElementById('casas')
            .setAttribute('class', 'links esconde');
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
          this.edificios = this.pisos = this.localidades = this.renta = false;
          this.provincia = true;
        }

        break;
      case 'localidades':
        this.localidades = !this.localidades;
        if (this.localidades) {
          document
            .getElementById('localidades')
            .setAttribute('class', 'links muestra');
          for (let x = 0; x < this.navegador.length; x++) {
            if (this.navegador[x] != 'localidades') {
              document
                .getElementById(this.navegador[x])
                .setAttribute('class', 'links esconde');
            }
          }
          this.edificios =
            this.pisos =
            this.casas =
            this.provincia =
            this.renta =
              false;
        } else {
          document
            .getElementById('localidades')
            .setAttribute('class', 'links esconde');
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
          this.edificios = this.pisos = this.casas = this.renta = false;
          this.provincia = true;
        }

        break;
      case 'provincia':
        this.provincia = !this.provincia;
        if (this.provincia) {
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
          for (let x = 0; x < this.navegador.length; x++) {
            if (this.navegador[x] != 'provincias') {
              document
                .getElementById(this.navegador[x])
                .setAttribute('class', 'links esconde');
            }
          }
        } else {
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
        }
        this.edificios =
          this.pisos =
          this.localidades =
          this.casas =
          this.renta =
            false;

        break;
      case 'renta':
        this.renta = !this.renta;
        if (this.renta) {
          document
            .getElementById('renta')
            .setAttribute('class', 'links muestra');
          for (let x = 0; x < this.navegador.length; x++) {
            if (this.navegador[x] != 'renta') {
              document
                .getElementById(this.navegador[x])
                .setAttribute('class', 'links esconde');
            }
          }
          this.edificios =
            this.pisos =
            this.localidades =
            this.casas =
            this.provincia =
              false;
        } else {
          document
            .getElementById('renta')
            .setAttribute('class', 'links esconde');
          document
            .getElementById('provincias')
            .setAttribute('class', 'links muestra');
          this.edificios = this.pisos = this.localidades = this.casas = false;
          this.provincia = true;
        }
        break;
      default:
        break;
    }
  }

  onChangePaginaLoc(value: any) {
    this.paginaLoc = value;
    for (let x = 1; x <= 3; x++) {
      if (x == value) {
        document
          .getElementById(`lo_pagina_${x}`)
          .setAttribute('class', 'muestra');
      } else {
        document
          .getElementById(`lo_pagina_${x}`)
          .setAttribute('class', 'esconde');
      }
    }
  }
  onChangePaginaFlats(value: any) {
    this.paginaFlats = value;
    for (let x = 1; x <= 5; x++) {
      if (x == value) {
        document
          .getElementById(`pisos_pagina_${x}`)
          .setAttribute('class', 'muestra');
      } else {
        document
          .getElementById(`pisos_pagina_${x}`)
          .setAttribute('class', 'esconde');
      }
    }
  }
}
